/**
 * How every number on a reservation is written, everywhere the console shows
 * one — three shapes, so an agent can tell whose number it is at a glance:
 *
 *   Ref #48213          ours: dispatch's number for a reservation or a quote
 *   Draft Ref #2291     ours, for a draft dispatch has not made a trip of yet
 *   Client Ref #PO-778  the booker's own (dispatch's `requesterResNo`)
 *
 * One module for the inbox, the campaign results and the operations dashboard,
 * because three screens each spelling the same number their own way is what
 * this replaced ("#48213", "Job #48213", "Quote Q-9921", "their ref 850675").
 * A reference stored or typed with its own "#" is not given a second one.
 */
const bare = (reference: string | number) =>
  String(reference)
    .trim()
    .replace(/^#\s*/, '');

export const ourRef = (kind: 'job' | 'quote' | 'draft', reference: string | number) =>
  `${kind === 'draft' ? 'Draft Ref' : 'Ref'} #${bare(reference)}`;

export const clientRef = (reference: string | number) => `Client Ref #${bare(reference)}`;
